module.exports = "pegasus/assets/col_2.png";